import { Controller } from "@hotwired/stimulus";
import { createConsumer } from "@rails/actioncable"


// import webNotificationChannel from "../../../javascript/channels/";

export default class extends Controller {
  static values = { id: Number };

  connect() {
    console.log('Web Notification... loading...');
    this.channel = createConsumer().subscriptions.create( 
      { channel: "WebNotificationChannel", 
        user_id: this.idValue
      }, 
      { received: (data) => this.renderPartial(data) } 
    ); 

    console.log(this.channel);
  }

  renderPartial(data) { 

    //  transmitting {"message"=>"Importazione completata", "user"=>{"id"=>1, "email"=>"support@procne.it", "deleted_at"=>nil, "created_at"=>"2024-07-16T08:07:56.996Z", "updated_at"=>"2024-07-16T08:07:56.996Z", "profile_id"=>1, "password_changed_at"=>"2024-07-16T08:07:56.329Z", "locale"=>"it", "totp_secret"=>nil, 

    console.log("Message:" + data.message);
    // console.log("user:" + data.user.id);
    console.log('Feed:' + data.html_partial)
    
    const notify = data.html_partial;
    var userMessage = document.querySelector(`#push-notify`); 
    if(data.user){
      userMessage = document.querySelector(`#msg-box-user-${data.user.id}`); 
    }
    if (notify && userMessage) { userMessage.outerHTML = notify; } 

    // const { message, user, index_data } = data; 
    // 
    // 
  }

  disconnect() { 
    this.channel.unsubscribe(); 
  } 
}

